

















import { Component, Vue } from 'vue-property-decorator';
import { ICourse } from '@/interfaces';
import { AjaxHelper } from '@/AjaxHelper';
import { truncate, showAxiosErrorMessage } from '@/utils';

import Card from '@/components/Card.vue';

interface Data {
  totalPages: number;
  courses: ICourse[];
}

@Component({
  name: 'courses-page',
  components: { Card },
  filters: { truncate },
  beforeRouteEnter: async (to, from, next) => {
    let courses: ICourse[] = [];
    try {
      const result = await AjaxHelper.get<Data>('/course');
      courses = result.courses;
    } catch (ex) {
      showAxiosErrorMessage(ex);
      courses = [];
    }

    next(vm => {
      (vm as any).courses = courses;
    });
  }
})
export default class CoursesComponent extends Vue {
  public courses: ICourse[] = [];
}
